import { cn } from '@/lib/utils';
import type { AutoCatchUpSweep } from '../types';
import { sweepStatusPresentation } from './autoCatchUpPresentation';

/** Pastille de statut, vocabulaire commun aux vues du rattrapage automatique. */
export function StatusPill({ label, className }: { label: string; className: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        className
      )}
    >
      {label}
    </span>
  );
}

export function SweepStatusBadge({ sweep }: { sweep: AutoCatchUpSweep }) {
  return <StatusPill {...sweepStatusPresentation(sweep.status, sweep.interrupted)} />;
}
